export interface Deck {
  id: string;
  user_id: string;
  name: string;
  card_ids: number[];
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface DeckWithCards {
  id: string;
  user_id: string;
  name: string;
  cards: Array<{
    id: number;
    name: string;
    image_url: string;
    grade: string;
    cost?: number;
    attack?: number;
    defense?: number;
    hp?: number;
    attribute?: string;
  }>;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface CreateDeckRequest {
  name: string;
  card_ids: number[];
  is_active?: boolean;
}

export interface UpdateDeckRequest {
  name?: string;
  card_ids?: number[];
  is_active?: boolean;
}

// 덱 검증 규칙
export const DECK_RULES = {
  MIN_CARDS: 30,
  MAX_CARDS: 30,
  MAX_DUPLICATES: 3, // 같은 카드 최대 3장
} as const;

